import './styles/App.scss'
import React, { Component } from 'react'
import Header from './Header'
import Admin from './Admin'
import ReportsView from './reports/ReportsView'

import {
  HashRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'

import { isAuthenticated } from '../api/auth'

import Auth from './Auth'
import Frontpage from './frontpage/Frontpage'

import fontawesome from '@fortawesome/fontawesome'
import {
  faAngleDown,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faExclamationTriangle,
  faSlidersH,
  faFilePdf,
  faDownload,
  faEye,
  faAngleRight,
  faSortUp,
  faSortDown,
  faSearch,
  faTools,
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faInfo,
  faBullhorn,
  faEyeSlash,
  faBolt,
  faTrash,
  faSave,
  faFileCsv
} from '@fortawesome/free-solid-svg-icons'

fontawesome.library.add(
  faSlidersH,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faExclamationTriangle,
  faAngleDown,
  faFilePdf,
  faFileCsv,
  faBullhorn,
  faSave,
  faAngleRight,
  faDownload,
  faFilePdf,
  faTrash,
  faBolt,
  faEye,
  faSortUp,
  faSortDown,
  faSearch,
  faTools,
  faCaretDown,
  faCaretUp,
  faInfoCircle,
  faInfo,
  faEyeSlash
)


import moment from 'moment'
import 'moment/locale/pt'
import NotFound from './NotFound'
import MonthlyReport from './reports/MonthlyReport'
import ReadingsExplorer from './explorer/ReadingsExplorer'
import About from './About'
moment.locale('pt')


const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <>
          <Header showNavigation={false} />
          <Component {...props} />;
        </>
      )
    }}
  />
)

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isAuthenticated()) {
        return <Auth/>
      } else {
        return (
          <>
            <Header showNavigation={true} />
            <Component {...props} />
          </>
        )
      }
    }}
  />
)


function App() {

  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/login" component={Auth} />
        <PrivateRoute exact path="/" component={Frontpage} />
        <PrivateRoute exact path="/reports" component={ReportsView} />
        <PrivateRoute exact path="/explorer" component={ReadingsExplorer} />
        <PrivateRoute exact path="/admin" component={Admin} />
        <PrivateRoute exact path="/report/:reportId" component={MonthlyReport} />
        <PrivateRoute exact path="/about" component={About} />
        <PrivateRoute component={NotFound} />
      </Switch>
    </Router>
  )
}


export default App
